import React from "react";
import { Option, RankIcon, Text, Wrapper } from "./style";
import { RowOption } from "../../../../../../../../pages/Design/types";

interface BodyProps {
  options: RowOption[];
}

const Ranking = ({ options }: BodyProps) => {
  return (
    <Wrapper>
      {options.map((option) => {
        return (
          <Option key={option.index}>
            <RankIcon>
              <hr />
              <hr />
            </RankIcon>
            <Text>{option.value}</Text>
          </Option>
        );
      })}
    </Wrapper>
  );
};

export default Ranking;
